import { useTheme, Avatar, Chip } from '@mui/material';
import { OfficialSummary } from '@networkRequest/operationsService';
import Utils from '../../../utils/utils';

const OperationOfficialAvatar = ({
  agency_official,
  variant = 'dark',
}: {
  agency_official: OfficialSummary;
  variant?: 'light' | 'dark';
}) => {
  const theme = useTheme();
  const officialName = Utils.fullName(agency_official.first_name, agency_official.last_name);
  return (
    <Chip
      variant='filled'
      avatar={<Avatar alt={officialName} src={agency_official.img_url || undefined} />}
      label={officialName}
      sx={{
        pr: '8px',
        color: theme.palette.text.primary,
        backgroundColor: variant === 'dark' ? theme.palette.blueGrey[100] : theme.palette.action.selected,
        '& .MuiChip-avatar': {
          marginRight: '6px',
        }
      }}
    />
  );
};

export default OperationOfficialAvatar;